<template>
  <div>
    <!-- Header Row 1 -->
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb />
        <b-button v-if="disabled"
                  :disabled="(menuRight.isreadonly == 1)?true:false || isPaid ? true : false"
                  size="sm"
                  style="float: right; margin-right:5px;"
                  variant="success"
                  @click="$refs.file.click()">Import Expenses</b-button>
        <b-button v-if="disabled"
                  :disabled="(menuRight.issaveas == 1)?true:false || isPaid ? true : false"
                  size="sm"
                  style="float: right; margin-right:5px;"
                  variant="success"
                  @click="exportExpenseTopay()">Export Expenses to Pay</b-button>
        <b-button size="sm"
                  :disabled="menuRight.issaveas == 1 ? true : false || dataH.dc_docno_ref == '' ? true : false || isPaid ? true : false"
                  style="float: right; margin-right: 5px"
                  variant="success"
                  @click="exportToExcel()">Export To Excel</b-button>
        <b-button size="sm"
                  style="float: right; margin-right:5px;"
                  variant="info"
                  :disabled="(menuRight.isreadonly == 1) ? true:false || isPaid ? true : false"
                  @click="onExpense()">Add Expenses</b-button>
        <b-button size="sm"
                  style="float: right; margin-right:5px;"
                  variant="success"
                  @click="onLabour()">Select Labour</b-button>

        <input type="file"
               ref="file"
               style="display: none"
               accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
               capture
               @change="importExcelTopay($event.target)" />
        <div class="separator mb-3"></div>
      </b-colxx>
    </b-row>
    <!-- Header Row 2 -->
    <b-row style="height:100px;">
      <b-colxx lg="12" sm="12" md="12" xs="12">
        <b-row>
          <b-colxx lg="6" sm="6" md="6" xs="12">
            <b-form-group style="margin-top: -10px"
                          label="ประเภท Plan"
                          disabled>
              <b-form-radio-group v-model="dataH.type_doc"
                                  style="margin-top: -5px">
                <b-form-radio value="4">Share Service</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-colxx>
          <b-colxx lg="2" sm="2" md="2" xs="12">
            <b>Plan Date</b>
            : {{ DateCh(date_old.start) }} - {{ DateCh(date_old.end) }}
          </b-colxx>

          <b-colxx lg="4" sm="4" md="4" xs="12" style="text-align:right;">
            <span v-if="dataH.dc_docno_ref != ''">
              Labour No :
              <b style="font-size:16px;">{{ dataH.dc_docno_ref }}</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
            <span v-if="dataH.pr_ref != ''">
              Ref. PR :
              <b style="font-size:16px; cursor: pointer;" @click="openprlist()">
                <u>{{ dataH.pr_ref }}</u>
              </b> &nbsp;&nbsp;&nbsp;&nbsp;
            </span>
            <div class="user d-inline-block">
              <b-dropdown class="dropdown-menu-right scollbar" right variant="empty" toggle-class="p-0" menu-class="mt-3" no-caret>
                <template slot="button-content">
                  <span class="name mr-1" style="font-size:14px; margin-top:-10px;">สถานะ</span>
                </template>
                <b-dropdown-item style="font-size:14px;">
                  <b-badge class="mb-1 classYGREEN" pill style="border-radius: 4px; padding:5px; width:130px;">Actual / Plan Visit</b-badge>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </b-colxx>
        </b-row>
      </b-colxx>
      <b-colxx lg="12" sm="4" md="6" xs="12">
        <b-row>
          <b-colxx lg="2" sm="2" md="2" xs="12">
            <label class="form-group has-float-label mb-4">
              <input type="input" v-model="dataH.dc_project_name" class="form-control" disabled />
              <span>Project</span>
            </label>
          </b-colxx>
          <b-colxx lg="1" sm="2" md="2" xs="12">
            <label class="form-group has-float-label mb-4">
              <input type="input" v-model="dataH.dc_job_name" class="form-control" disabled />
              <span>Job Type</span>
            </label>
          </b-colxx>
          <b-colxx lg="3" sm="4" md="4" xs="12">
            <label class="form-group has-float-label mb-4">
              <input type="input" v-model="dataH.dc_remark" class="form-control" />
              <span>Remark</span>
            </label>
          </b-colxx>
          <b-colxx lg="1" sm="1" md="1" xs="12">
            <b-input-group>
              <div class="form-group has-float-label">
                <v-date-picker mode="single"
                               :min-date="minDate"
                               :max-date="maxDate"
                               v-model="dataH.dc_job_start_date"
                               :input-props="{ class:'form-control', placeholder: $t('form-components.date') }"
                               @input="onloadLabourByDate(dataH.dc_docno_ref, dataH.dc_job_start_date, dataH.dc_job_end_date)"></v-date-picker>
                <span>Start Date</span>
              </div>
            </b-input-group>
          </b-colxx>
          <b-colxx lg="1" sm="1" md="1" xs="12">
            <b-input-group>
              <div class="form-group has-float-label">
                <v-date-picker mode="single"
                               :min-date="minDate"
                               :max-date="maxDate"
                               v-model="dataH.dc_job_end_date"
                               :input-props="{ class:'form-control', placeholder: $t('form-components.date') }"
                               @input="onloadLabourByDate(dataH.dc_docno_ref, dataH.dc_job_start_date, dataH.dc_job_end_date)"></v-date-picker>
                <span>End Date</span>
              </div>
            </b-input-group>
          </b-colxx>
          <!-- <b-colxx lg="2" sm="3" md="3" xs="12">
            <b-button
              size="sm"
              variant="primary"
              @click="onloadLabourByDate(dataH.dc_job_start_date, dataH.dc_job_end_date)"
              :disabled="(dataH.dc_docno_ref=='' || menuRight.isreadonly == 1)?true:false"
            >Create To Pay</b-button> -->
          <!-- <b-button
                  size="sm"
                  :disabled="menuRight.isprint == 1 ? true : false || dataH.dc_docno_ref == '' ? true : false"
                  style="float: right; margin-right: 5px"
                  variant="success"
                    @click="exportToExcel()"
                >Export To Excel</b-button
          > -->
          <!-- </b-colxx> -->
        </b-row>
      </b-colxx>
    </b-row>
    <!-- Detail -->
    <b-row>
      <b-colxx xxs="12">
        <b-tabs content-class="mt-1" v-model="tabIndex">
          <b-tab title="Setsup Labour" active @click="hideExport(tabIndex)">
            <template slot="title">
              <i class="simple-icon-people"></i> Labour To Pay Share Service
            </template>
            <b-card :style="'height:'+(height-343)+'px;'">
              <div class="zui-wrapper" v-if="columnsH.day">
                <div class="zui-scroller">
                  <div class="loading" v-if="loading"></div>
                  <table class="zui-table" id="payexcel">
                    <thead style="display:block;width:100%;table-layout:fixed;">

                      <tr>
                        <th colspan="8"></th>
                        <th v-for="v in columnsH.year"
                            v-bind:key="v.id"
                            :colspan="v.col">
                          {{ v.title }}
                        </th>
                        <th rowspan="3" class="width-100">Actual Visit</th>
                        <th rowspan="3" class="width-100">Amount จ่ายจริง (Month)</th>

                        <th rowspan="3"
                            class="width-100"
                            style="width:100px;"
                            v-for="(vv,ii) in expData"
                            :key="vv.expens_code"><span v-if="vv.taxper" style="color:#b71c1c; padding-top:20px;">หักภาษี {{ vv.taxper}}%</span><br>{{vv.expens_name}}</th>

                        <th rowspan="3" class="width-100">รวมค่าจ้าง</th>
                        <th rowspan="3" class="width-100">หักภาษีค่าจ้าง</th>
                        <th rowspan="3" class="width-100">หักภาษีค่าใช้จ่าย</th>
                        <th rowspan="3" class="width-100">รวมหักภาษี</th>
                        <th rowspan="3" class="width-100">ค่าจ้างสุทธิ</th>
                        <th rowspan="3" class="width-150">เลขที่บัญชี</th>
                        <th rowspan="3" class="width-300">ชื่อธนาคาร</th>
                        <th rowspan="3" class="width-150">เลขที่บัตรประชาชน</th>
                        <th rowspan="3" class="width-450">ที่อยู่</th>

                        <th rowspan="3" class="width-30">:</th>
                      </tr>
                      <tr>
                        <th rowspan="2" class="width-50">No</th>
                        <th rowspan="2" class="width-150">ภาค</th>
                        <th rowspan="2" class="width-150">จังหวัด</th>
                        <th rowspan="2" class="width-150">เขต</th>
                        <th rowspan="2" class="width-250">Supervisor</th>
                        <th rowspan="2" class="width-250">Outsource</th>
                        <th rowspan="2" class="width-200">Position</th>
                        <th rowspan="2" class="width-150">Amount/Visit (Month)</th>
                        <th v-for="v in columnsH.month"
                            v-bind:key="v.id"
                            :colspan="v.col">{{ v.title }}</th>
                      </tr>
                      <tr>
                        <th v-for="v in columnsH.day"
                            v-bind:key="v.id"
                            @click="checkAll(v)"
                            class="width-100 widthClass"
                            v-bind:class="{'classActiveH':(v.hld == 1),'classActivePaytrue':(v.pay == 1 && v.hld != 1),'classActivePay':(v.pay == 2 && v.hld != 1)}">{{ v.title }}</th>
                      </tr>
                    </thead>
                    <tbody :style="'display:block;height:'+(height-485)+'px; overflow:auto; overflow-x: hidden;'">
                      <tr v-for="(v,i) in detailList" :key="i" @click="rowcolor(v)" v-bind:class="{'selected': v.slectrow == 'selected',  '': v.slectrow != 'selected'}">
                        <td class="width-50" style="text-align:center;">
                          <b>{{ v.item_sort }}.</b>
                        </td>
                        <td class="width-150">{{ v.part_name }}</td>
                        <td class="width-150">{{ v.province_name}}</td>
                        <td class="width-150">{{ v.area_name}}</td>
                        <td class="width-250">{{ v.dc_user_control_name }}</td>
                        <td class="width-250">{{ v.dc_team_id_name }}</td>
                        <td class="width-200">{{ v.dc_position_name }}</td>
                        <td class="width-150"
                            style="text-align:right;">
                          {{ v.dc_labour_amount | currency }}&nbsp;&nbsp;
                        </td>
                        <td class="width-100 classdf"
                            v-for="(vv,ii) in columnsH.day"
                            v-bind:class="{'classholiday':(vv.daywh == 'sat' || vv.daywh == 'sun'),'classYGREEN': v[v.dc_team_id + '_' + vv.key + '_visitBG'] == 'G'}"
                            v-bind:key="ii">
                          {{ v[v.dc_team_id + "_" + vv.key + "_visit"] }}
                        </td>

                        <td class="width-100" style="text-align:center;">{{ v.status_green1 }}</td>
                        <td class="width-100" style="text-align:right;">{{ v.dc_net_amount  }}</td>

                        <td class="width-100" v-for="(vv,ii) in expData" :key="vv.expens_code">
                          <number2 v-model="v[vv.expens_code]"
                                   size="xs"
                                   placeholder="0.00"
                                   style="height: 25px; text-align:right; width:98px;"
                                   decimals="2"
                                   @el-blur="onkeypressValue(v,vv)"></number2>
                        </td>
                        <td class="width-100" style="text-align:right;">{{ v.total_wage  | currency }}</td>
                        <td class="width-100" style="text-align:right;">{{ v.total_wage_tax  | currency }}</td>
                        <td class="width-100" style="text-align:right;">{{ v.total_exp_tax  | currency }}</td>
                        <td class="width-100" style="text-align:right;">{{ v.total_amt_tax  | currency }}</td>
                        <td class="width-100" style="text-align:right;">{{ v.total_amt_net  | currency }}</td>
                        <td class="width-150" style="text-align:center;">&nbsp;&nbsp;<b>{{ v.account_number }}</b></td>
                        <td class="width-300" style="text-align:left;"> {{ v.bank_name }} </td>
                        <td class="width-150" style="text-align:center;"> &nbsp;&nbsp;<b>{{ v.dc_id_card }}</b></td>
                        <td class="width-450" style="text-align:left;"> {{ v.regi_address }}  {{ v.regi_zip_code }} </td>
                        <td class="width-30"></td>
                      </tr>
                    </tbody>
                    <tfoot style="display:block;width:100%;table-layout:fixed;">
                      <tr>
                        <th class="width-50"></th>
                        <th class="width-150"></th>
                        <th class="width-150"></th>
                        <th class="width-150"></th>
                        <th class="width-250"></th>
                        <th class="width-250"></th>
                        <th class="width-200"></th>
                        <th class="width-150" style="text-align:right;">{{ totalBT.dc_labour_amount | currency }}</th>
                        <th class="width-100"
                            style="100px;"
                            v-for="(vv,ii) in columnsH.day"
                            v-bind:key="ii">
                        </th>
                        <th class="width-100" style="text-align:center;"><b>{{ totalBT.status_green1 || 0 }}</b></th>
                        <th class="width-100" style="text-align:center;"><b>{{ totalBT.dc_net_amount | currency }}</b></th>

                        <th class="width-100"
                            v-for="(vv,ii) in expData"
                            :key="vv.expens_code"
                            style="text-align:right;">
                          <b>{{ totalBT[vv.expens_code] | currency }}</b>&nbsp;&nbsp;
                        </th>

                        <th class="width-100" style="text-align:right;"><b>{{ totalBT.total_wage | currency }}</b></th>
                        <th class="width-100" style="text-align:right;"><b>{{ totalBT.total_wage_tax | currency }}</b></th>
                        <th class="width-100" style="text-align:right;"><b>{{ totalBT.total_exp_tax | currency }}</b></th>
                        <th class="width-100" style="text-align:right;"><b>{{ totalBT.total_amt_tax | currency }}</b></th>
                        <th class="width-100" style="text-align:right;"><b>{{ totalBT.total_amt_net  | currency }}</b></th>
                        <th class="width-150"> </th>
                        <th class="width-300"> </th>
                        <th class="width-150"> </th>
                        <th class="width-450"> </th>
                        <th class="width-30">:</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </b-card>
          </b-tab>
          <b-tab title="Labour To Pay Share Service List" @click="hideExport(tabIndex)">
            <template slot="title">
              <i class="iconsminds-dollar-sign-2"></i> Labour To Pay Share Service List
            </template>
            <b-card :style="'height:'+(height-343)+'px;'">
              <div class="zui-wrapper">
                <div class="zui-scroller">
                  <table class="tableMain" id="testTable">
                    <thead style="display:block;width:100%;table-layout:fixed;">
                      <tr>
                        <th class="width-150">Del.</th>
                        <th class="width-50">No.</th>
                        <th class="width-130">Doc. No</th>
                        <th class="width-130">Project No.</th>
                        <th class="width-300">Project Name</th>
                        <th class="width-300">Job Name</th>
                        <th class="width-300">Remark</th>
                        <th class="width-130">Start Date</th>
                        <th class="width-130">End Date</th>
                        <th class="width-130">Amount</th>
                        <th class="width-130">Tax Amount</th>
                        <th class="width-130">Net Amount</th>
                        <th class="width-130">Status</th>
                        <th class="width-130">OF No.</th>
                      </tr>
                    </thead>
                    <tbody :style="'display:block;height:'+(height-425)+'px; overflow:auto; overflow-x: hidden;'">
                      <tr v-for="(v,i) in datapayList" :key="i">
                        <td class="width-150" style="text-align:center;">
                          <img src="../../../assets/img2/garbage.svg"
                               style="margin-top:-12px;"
                               width="20"
                               title="Delete"
                               :class="{'disabled-menu': menuRight.isreadonly == 1 }"
                               @click="onDeletePay(v)" />&nbsp;&nbsp;
                          <i class="simple-icon-list"
                             style="font-size:20px;"
                             @click="onListPay(v)"></i>&nbsp;&nbsp;
                          <img src="../../../assets/img2/export.svg"
                               style="margin-top:-12px;"
                               width="20"
                               title="รายงานการทำงาน Outsource"
                               @click="onExOutsource(v)" />
                          <i class="simple-icon-pencil"
                             style="font-size:20px;"
                             @click="onListPayEdit(v)"></i>&nbsp;&nbsp;
                        </td>
                        <td class="width-50" style="text-align:center;">{{ i + 1 }}</td>
                        <td class="width-130" style="text-align:center;">
                          <b>{{ v.dc_docno }}</b>
                        </td>
                        <td class="width-130" style="text-align:center;">
                          <b>{{ v.dc_project_code }}</b>
                        </td>
                        <td class="width-300" style="text-align:left;">{{ v.dc_project_name }}</td>
                        <td class="width-300" style="text-align:left;">{{ v.dc_job_name }}</td>
                        <td class="width-300" style="text-align:left;">
                          <b>{{ v.dc_remark }}</b>
                        </td>
                        <td class="width-130" style="text-align:center;">
                          <span style="color:#FF5722;">
                            <b>{{ DateCh(v.dc_job_start_date) }}</b>
                          </span>
                        </td>
                        <td class="width-130" style="text-align:center;">
                          <span style="color:#FF5722;">
                            <b>{{ DateCh(v.dc_job_end_date) }}</b>
                          </span>
                        </td>
                        <td class="width-130" style="text-align:right;">{{ v.amount | currency }}</td>
                        <td class="width-130"
                            style="text-align:right;">
                          {{ v.tax_amount | currency }}
                        </td>
                        <td class="width-130"
                            style="text-align:right;">
                          {{ v.net_amount | currency }}
                        </td>
                        <td class="width-130" style="text-align:center;">
                          <span v-bind:class="{'inprogress':(!v.ref_of),'successfully':(v.ref_of)}">{{ (v.ref_of)?'successfully':'Is in progress' }}</span>
                        </td>
                        <td class="width-130" style="text-align:center;">{{ v.ref_of }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-card>
          </b-tab>
        </b-tabs>
      </b-colxx>
    </b-row>
    <!-- Paging -->
    <div class="chat-input-container" style="height:50px;">
      <div>
        <b-row v-if="lastPage>1">
          <b-colxx xxs="12">
            <b-pagination-nav v-model="page"
                              @input="Getpage()"
                              :number-of-pages="perPage"
                              base-url="#"
                              align="center">
              <template v-slot:next-text>
                <i class="simple-icon-arrow-right" />
              </template>
              <template v-slot:prev-text>
                <i class="simple-icon-arrow-left" />
              </template>
              <template v-slot:first-text>
                <i class="simple-icon-control-start" />
              </template>
              <template v-slot:last-text>
                <i class="simple-icon-control-end" />
              </template>
            </b-pagination-nav>
          </b-colxx>
        </b-row>
      </div>
    </div>

    <!-- Modal -->
    <div>
      <b-modal v-model="openprshow"
               centered
               title="Plan Y List"
               size="lg"
               :hide-footer="true"
               style="width:80%;"
               :no-close-on-backdrop="true"
               :no-close-on-esc="true">
        <template slot="modal-title">
          <span>PR Detail &nbsp;&nbsp;&nbsp;&nbsp;</span>
        </template>
        <b-row class="icon-cards-row mb-3">
          <b-colxx xxs="12" sm="12" md="12" lg="12">
            <vue-perfect-scrollbar class="scroll dashboard-list-with-thumbs"
                                   :settings="{ suppressScrollX: true, wheelPropagation: false }">
              <table class="tableMain">
                <thead>
                  <tr>
                    <th style="width:50px;">ID</th>
                    <th style="width:150px;">costcode</th>
                    <th style="width:200px;">Type code</th>
                    <th>Type Name</th>
                    <th style="width:150px;">Qty</th>
                    <th style="width:150px;">Amount</th>
                    <!-- <th style="width:150px;">Qty actual</th> -->
                    <th style="width:150px;">Amount actual</th>
                    <!-- <th style="width:150px;">Qty Bal.</th> -->
                    <th style="width:150px;">Amount Bal.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(v,i) in objcontronlist" :key="i">
                    <td style="text-align:center;">{{ i+1}}</td>
                    <td style="text-align:center;"><b>{{ v.costcode }}</b></td>
                    <td>{{ v.type_code }}</td>
                    <td style="text-align:left;">{{ v.type_name }} </td>
                    <td style="text-align:right;">{{ v.qty_control | currency }} </td>
                    <td style="text-align:right;">{{ v.amt_control | currency }} </td>
                    <td style="text-align:right; color:#ff6600;" :rowspan="v.rowpan" v-show="v.rowpan">{{ v.amt_bal | currency }}</td>
                    <td style="text-align:right; color:#669900;" :rowspan="v.rowpan" v-show="v.rowpan">{{ (v.amt_total -v.amt_bal) | currency }}</td>
                  </tr>
                </tbody>
              </table>
            </vue-perfect-scrollbar>
          </b-colxx>
        </b-row>
      </b-modal>
    </div>

    <div>
      <paydetail ref="Ctpaydetail" v-on:ct-data-click="onModalReturn($event)"></paydetail>
    </div>
    <div>
      <expenseother ref="Ctexpenseother" v-on:ct-data-click="onModalReturn($event)"></expenseother>
    </div>
    <div>
      <labour ref="Ctlabour" v-on:ct-data-click="onModalReturn($event)"></labour>
    </div>
    <div id="mybutton">
      <div class="circle-ripple_in" :class="{'disabled-menu': menuRight.isreadonly == 1}" @click="SavePlanY()">
        <div id="wrapper_test">
          <span class="textcheck" :class="{'disabled-menu': menuRight.isreadonly == 1}"> Save</span>
        </div>
      </div>
    </div>
    <loadingbox :active="loadingx"
                spinner="spinner"
                color="dimgray"
                :text="export_progress"
                is-full-screen />
  </div>
</template>

<script>
  import expenseother from "@/components/Center/expenseother";
  import labour from "@/components/Center/labour";
  import paydetail from "@/components/Center/pay_detail";
  import { apiUrl, xtools } from "@/constants/config";
  import ExcelJS from "exceljs";
  import { saveAs } from "file-saver";
  import $ from 'jquery';
  import linq from "js-linq";
  import moment from "moment";
  import readXlsxFile from 'read-excel-file';
  import loadingbox from "vue-element-loading";
  import vSelect from "vue-select";
  import Decimal from '../../../../node_modules/decimal.js/decimal';

  var tabCostheight = window.innerHeight;
  const $linq = function (arr) {
    return linq.from(arr);
  };
  
  export default {
    components: { vSelect, labour, expenseother, paydetail, loadingbox },
    data() {
      return {
        date_old: {
          start: new Date(),
          end: new Date()
        },
        minDate: new Date(),
        maxDate: new Date(),
        minPaidDate: new Date(),
        dataRepeatshow: false,
        menuRight: window.menuRight,
        loading: false,
        loadingx: false,
        export_progress: "",
        disabled: true,
        skip: 0,
        page: 1,
        perPage: 1,
        from: 0,
        to: 0,
        total: 0,
        lastPage: 15,
        limitPage: 50,
        tabIndex: 1,
        diff_date: 0,
        storeloading: false,
        height: tabCostheight,
        objcontron_bal: {},
        monthToInt: {
          "1": "JAN",
          "2": "FEB",
          "3": "MAR",
          "4": "APR",
          "5": "MAY",
          "6": "JUN",
          "7": "JUL",
          "8": "AUG",
          "9": "SEP",
          "10": "OCT",
          "11": "NOV",
          "12": "DEC"
        },
        dataList: [],
        detailList: [],
        planDetailAll: [],
        calToPayList: [],
        dataexpH: [],
        datapay_detall: [],
        countDate: [],
        columns: [],
        columnsH: [],
        visit_per_brand_header: [],
        apiBase: apiUrl,
        dataH: {
          type_doc: 1,
          labour_plus: 1,
          dc_docno: "",
          dc_project_code: "",
          dc_project_code2: "",
          dc_project_name: "",
          dc_job_code: "",
          dc_job_name2: "",
          dc_job_name: "",
          dc_remark: "",
          dc_job_start_date: new Date(),
          dc_job_end_date: new Date(),
          dc_days: 0,
          dc_job_expens_code: "",
          dc_docno_ref: "",
          exp_labour: "",
          daymaxpay: new Date(),
          new_startday: new Date(),
          tax_amount: 0,
          net_amount: 0,
          pr_ref: "",
        },

        totalBT: {
          dc_days_plan: 0,
          dc_days: 0,
          dc_days_05: 0,
          dc_hid_days: 0,
          dc_labour_amount: 0,
          dc_labour_amount: 0,
          dc_amount: 0,
          dc_cut_amount: 0,
          dc_tax_amount: 0,
          dc_net_amount: 0,
          dc_wht_amount: 0,
          dc_total_amount: 0,
          dc_panding_days: 0,
          dc_duct_days: 0,
          dc_RP_days: 0,
          dc_total_day: 0,
          dc_total_plan: 0,
          dc_tatal_diff: 0,
          dc_deduct_amt: 0,
          dc_labour_amount: 0,
          dc_amt_deduct: 0,
          total_amt_net: "",
          dc_labour_amount2: 0
        },
        jobData: [],
        setStatusShow: false,
        accountshow: false,
        provinceshow: false,
        storeshow: false,
        itemSelect: {},
        setkey: "",
        setval: "",
        brand_key: "",
        accountList: [],
        holidayData: [],
        dataRepeat: [],
        expData: [],
        dataExpList: [],
        datapayList: [],
        openprshow: false,
        objcontron: {},
        objcontronlist: [],
        paylistbydocno: [],
        afterpayList: [],
        afterPayAmount: [],
        afterPayExpense: [],
        afterPayExpenseTotal: [],
        afterPayExpenseList: [],
        expDataD: [],
        data2Default: [],
        beforeTax: [],
        afterTax: [],
        sumExpenseList: [],
        company: {},
        checkExport: false,
        isPaid: false
      };
    },
    methods: {
      /* Main Function */
      async onloadLabour(dc_docno, start, end) {
        this.$set(this, "export_progress", "กำลังโหลดข้อมูลรายการทำจ่าย กรุณารอซักครู่");
        this.$set(this, "loadingx", true);

        this.skip = 0;
        let startdate = moment(start).format('YYYY-MM-DD')
        let enddate = moment(end).format('YYYY-MM-DD')

        if (dc_docno) {
          let data = await xtools.getServer(
            "AccountingforLabor/Transaction/labourShareServiceToPay_ReadByDocno?dc_code=" +
            dc_docno + '&startdate=' + startdate + '&enddate=' + enddate
          );

          this.minDate = data.data.h.daymaxpay
            ? moment(data.data.h.daymaxpay, "YYYY-MM-DD")
              .add(1, "days")
              .toDate()
            : moment(data.data.h.dc_job_start_date, "YYYY-MM-DD").toDate();
          this.maxDate =
            moment(new Date(), "YYYY-MM-DD").toDate() >=
              moment(data.data.h.dc_job_end_date, "YYYY-MM-DD").toDate()
              ? moment(data.data.h.dc_job_end_date, "YYYY-MM-DD").toDate()
              : moment(new Date(), "YYYY-MM-DD").toDate();          

          this.dataH = data.data.h;
          this.dataH.dc_remark_ref = data.data.h.dc_remark;
          this.expDataD = data.data.expD;
          this.dataH.dc_docno_ref = data.data.h.dc_docno;
          this.dataH.dc_docno = "";
          this.dataH.dc_remark = "";

          var total_d = 0;
          data.data.old.forEach((v, i) => {
            var dateDff = this.getDeffDate(v.dc_job_start_date, v.dc_job_end_date);
            total_d = parseInt(total_d) + parseInt(dateDff)
          });
          this.diff_date = total_d;

          this.dataH.dc_job_start_date = moment(data.data.h.dc_job_start_date, "YYYY-MM-DD").toDate();
          this.dataH.dc_job_end_date = moment(enddate, "YYYY-MM-DD").toDate();

          this.dataH.dc_job_name2 = {
            value: this.dataH.dc_job_code,
            label: this.dataH.dc_job_name
          };

          this.dataList = data.data.d;
          this.planDetailAll = data.data.sub_d;
          this.countDate = data.data.count_date;
          this.calToPayList = data.data.cal_group;

          this.datapayList = data.data.old;
          this.dataExpList = data.data.expD;
          this.dataexpH = data.data.expH;
          this.datapay_detall = data.data.pay_detall;

          this.perPage = this.dataList.length / this.limitPage < 1 ? 1 : this.dataList.length / this.limitPage + 1;

          this.genReport();
          this.onloadprcontrol(data.data.h.pr_ref, data.data.h.costcode);
          this.onloadprcontrollist(data.data.h.pr_ref, data.data.h.costcode);
          this.loadpaylistbydocno(data.data.h.dc_docno_ref);

          if (startdate != this.minDate) {
            this.onloadLabourByDate(this.minDate, this.maxDate)
          }
        }
      },

      async onloadLabourByDate(docno, start, end) {
        this.$set(this, "export_progress", "กำลังโหลดข้อมูลรายการทำจ่าย กรุณารอซักครู่")
        this.$set(this, "loadingx", true);

        this.isPaid = false;
        this.dataList = [];
        this.planDetailAll = [];
        this.countDate = [];

        this.skip = 0;
        let startdate = moment(start).format('YYYY-MM-DD')
        let enddate = moment(end).format('YYYY-MM-DD')

        if (docno) {
          let data = await xtools.getServer(
            "AccountingforLabor/Transaction/labourShareServiceToPay_ReadByDocno?dc_code=" +
            docno + '&startdate=' + startdate + '&enddate=' + enddate
          );

          this.date_old = {
            start: data.data.h.dc_job_start_date,
            end: data.data.h.dc_job_end_date
          };

          this.minDate = data.data.h.daymaxpay
            ? moment(data.data.h.daymaxpay, "YYYY-MM-DD")
              .add(1, "days")
              .toDate()
            : moment(data.data.h.dc_job_start_date, "YYYY-MM-DD").toDate();
          this.maxDate =
            moment(new Date(), "YYYY-MM-DD").toDate() >=
              moment(data.data.h.dc_job_end_date, "YYYY-MM-DD").toDate()
              ? moment(data.data.h.dc_job_end_date, "YYYY-MM-DD").toDate()
              : moment(new Date(), "YYYY-MM-DD").toDate();

          this.dataH = data.data.h;
          this.dataH.dc_remark_ref = data.data.h.dc_remark;
          this.expDataD = data.data.expD;
          this.dataH.dc_docno_ref = data.data.h.dc_docno;
          this.dataH.dc_docno = "";
          this.dataH.dc_remark = "";

          this.dataH.dc_job_start_date = moment(startdate, "YYYY-MM-DD").toDate();
          this.dataH.dc_job_end_date = moment(enddate, "YYYY-MM-DD").toDate();

          this.dataH.dc_job_name2 = {
            value: this.dataH.dc_job_code,
            label: this.dataH.dc_job_name
          };

          this.expDataD = data.data.expD;

          var total_d = 0;
          data.data.old.forEach((v, i) => {
            var dateDff = this.getDeffDate(v.dc_job_start_date, v.dc_job_end_date);
            total_d = parseInt(total_d) + parseInt(dateDff)
          });
          this.diff_date = total_d;

          this.dataList = data.data.d;
          this.planDetailAll = data.data.sub_d;
          this.countDate = data.data.count_date;
          this.calToPayList = data.data.cal_group;

          this.datapayList = data.data.old;
          this.dataExpList = data.data.expD;
          this.dataexpH = data.data.expH;
          this.datapay_detall = data.data.pay_detall;

          var maxpayday = moment(this.dataH.daymaxpay, "YYYY-MM-DD");
          var endplanday = moment(this.dataH.dc_job_end_date, "YYYY-MM-DD");
          var diff_days = moment.duration(maxpayday.diff(endplanday)).asDays();

          if (diff_days == 0) {
            this.isPaid = true;
            this.dataH.dc_job_start_date = new Date();
            this.dataH.dc_job_end_date = new Date();
            this.dataList = [];
            this.planDetailAll = [];
            this.countDate = [];
            this.calToPayList = [];
          }

          this.perPage = this.dataList.length / this.limitPage < 1 ? 1 : this.dataList.length / this.limitPage + 1;

          this.genReport('pay');
          this.onloadprcontrol(data.data.h.pr_ref, data.data.h.costcode);
          this.onloadprcontrollist(data.data.h.pr_ref, data.data.h.costcode);
          this.loadpaylistbydocno(data.data.h.dc_docno_ref);
        }
      },

      genReport(wh_g) {
        if (this.menuRight.isreadonly == 1) { return; }
        // สร้าง วันที่ ตามที่เลือก
        this.columns = [];
        var datapay = [];

        var forYMD = {
          year: [],
          month: [],
          day: []
        };

        var v_s =
          moment(this.dataH.dc_job_start_date).format("YYYY") +
          "-" +
          moment(this.dataH.dc_job_start_date).format("MM") +
          "-" +
          moment(this.dataH.dc_job_start_date).format("DD");
        var v_e =
          moment(this.dataH.dc_job_end_date).format("YYYY") +
          "-" +
          moment(this.dataH.dc_job_end_date).format("MM") +
          "-" +
          moment(this.dataH.dc_job_end_date).format("DD");

        var start = moment(v_s, "YYYY-MM-DD");
        var end = moment(v_e, "YYYY-MM-DD");
        var vdff = moment.duration(start.diff(end)).asDays();
        var days = vdff.toString().replace("-", "");
        var start_date = parseInt(
          moment(this.dataH.dc_job_start_date, "YYYY-MM-DD").format("D")
        );

        var limit = parseInt(days) + 1;
        var i;

        let dataC = [];
        this.dataH.paylist.forEach((v, i) => {
          var v_now =
            moment(v.dc_job_start_date).format("YYYY") +
            "-" +
            moment(v.dc_job_start_date).format("MM") +
            "-" +
            moment(v.dc_job_start_date).format("DD");
          var v_end =
            moment(v.dc_job_end_date).format("YYYY") +
            "-" +
            moment(v.dc_job_end_date).format("MM") +
            "-" +
            moment(v.dc_job_end_date).format("DD");
          var v_start = moment(v_now, "YYYY-MM-DD");
          var v_end = moment(v_end, "YYYY-MM-DD");

          var v_vdff = moment.duration(v_start.diff(v_end)).asDays();
          var v_days = v_vdff.toString().replace("-", "");
          var v_limit = parseInt(v_days) + 1;

          var ii;
          for (ii = 0; ii < v_limit; ii++) {
            let v_createdDate = moment(v.dc_job_start_date)
              .utc()
              .format();
            let v_expirationDate = moment(v_createdDate).add(ii, "d");
            datapay.push({
              date: v_expirationDate.format("YYYY-MM-DD"),
              pay: v.ref_of != null
            });
          }
        });

        // this.h_data.dc_days = limit;
        for (i = 0; i < limit; i++) {
          let createdDate = moment(this.dataH.dc_job_start_date)
            .utc()
            .format();
          let expirationDate = moment(createdDate).add(i, "d");
          let d_rend = i; // Math.floor(1000000 + Math.random() * 9000000);
          var hld = $linq(this.holidayData)
            .where(
              x =>
                moment(x.holiday_date, "YYYY-MM-DD").format("DD/MM/YYYY") ==
                moment(expirationDate, "YYYY-MM-DD").format("DD/MM/YYYY")
            )
            .toArray();
          var pay_ =
            $linq(datapay)
              .where(
                x =>
                  moment(x.date, "YYYY-MM-DD").format("DD/MM/YYYY") ==
                  moment(expirationDate, "YYYY-MM-DD").format("DD/MM/YYYY")
              )
              .firstOrDefault() || null;
          let d = {
            width: 20,
            title: expirationDate.format("D"),
            key:
              "columns_" +
              expirationDate.format("YYYY") +
              "-" +
              expirationDate.format("MM") +
              "-" +
              expirationDate.format("DD"),
            year: expirationDate.format("YYYY"),
            month: expirationDate.format("M"),
            day: expirationDate.format("D"),
            daywh: expirationDate.format("ddd").toLowerCase(),
            value: "",
            id: d_rend,
            hld: hld.length,
            pay: pay_ == null ? 0 : pay_.pay == true ? 1 : 2
          };
          dataC.push(d);
          forYMD.day.push(d);
        }

        var ycount = 0;
        let groupByyear = $linq(dataC)
          .groupBy(g => g.year)
          .select(s => {
            let data = s.values;
            let y_rend = Math.floor(1000000 + Math.random() * 9000000);
            forYMD.year.push({
              id: y_rend,
              title: data[0].year,
              col: $linq(dataC)
                .where(x => x.year === data[0].year)
                .toArray().length
            });
            return {
              width: 20,
              title: data[0].year,
              key: data[0].key,
              data: data
            };
          })
          .toArray();
        groupByyear.forEach((value, index) => {
          let groupBymonth = $linq(value.data)
            .groupBy(g => g.month)
            .select(s => {
              let data2 = s.values;
              let m_rend = Math.floor(1000000 + Math.random() * 9000000);
              forYMD.month.push({
                id: m_rend,
                title: this.monthToInt[data2[0].month],
                col: data2.length
              });

              return {
                width: 20,
                title: this.monthToInt[data2[0].month],
                key: data2[0].key,
                data: data2
              };
            })
            .toArray();
          value.data = groupBymonth;
        });

        this.columnsH = forYMD;
        this.columns = groupByyear;

        let datapay_detall_dic = {};
        for (let xx of this.datapay_detall || []) {
          datapay_detall_dic[`${xx.code}||${xx.x.dc_itemno_ref}`] = xx;
        }

        let countDate_dic = {};
        for (let xx of this.countDate || []) {
          countDate_dic[`${xx.dc_team_id}||${xx.setkey}`] = xx;
        }

        //this.calToPayList
        let calToPayList_dic = {};
        for (let xx of this.calToPayList || []) {
          calToPayList_dic[`${xx.dc_team_id}`] = xx;
        }

        //this.planDetailAll
        let planDetailAll_dic = {};
        for (let xx of this.planDetailAll || []) {
          planDetailAll_dic[`${xx.dc_team_id}`] = planDetailAll_dic[`${xx.dc_team_id}`] || [];
          if (xx.visit_status == '1') {
            planDetailAll_dic[`${xx.dc_team_id}`].push(xx.visit_status)
          }
        }

        this.dataList.forEach((f) => {

          var ex_tax = 0;
          var ex_tax_total = 0;
          var ex_total = 0;

          this.dataexpH.forEach((v2, i2) => {
            var ex =
              //  $linq(this.datapay_detall || []).where(x => x.code == v2.code && x.dc_itemno_ref == f.dc_itemno).firstOrDefault() || null;
              datapay_detall_dic[`${v2.code}||${f.dc_itemno}`];

            if (ex) {
              f[v2.code] = ex.amount;
              ex_tax = ex_tax + (parseFloat(ex.amount || 0) * parseFloat(ex.tax_per || 0)) / 100 || 0;
              ex_total = ex_total + ex.amount;
              ex_tax_total = ex_tax_total + parseFloat(ex.amount || 0) - parseFloat(ex_tax || 0)
            }
          });

          this.columnsH.day.forEach((v, i) => {
            let co = countDate_dic[`${f.dc_team_id}||${v.key}`] || {}

            //let count_visit = $linq(this.countDate)
            //  .where((w) => w.dc_team_id == f.dc_team_id && w.setkey == v.key)
            //  .select((s) => s.count_visit)
            //  .firstOrDefault() || 0;

            //let value_status = $linq(this.countDate)
            //  .where((w) => w.dc_team_id == f.dc_team_id && w.setkey == v.key)
            //  .select((s) => s.status_green1)
            //  .firstOrDefault() || 0;

            let count_visit = co.count_visit || 0;
            let value_status = co.status_green1 || 0;

            if (count_visit != 0) {
              f[f.dc_team_id + "_" + v.key + "_visit"] = value_status + "/" + count_visit;
              f[f.dc_team_id + "_" + v.key + "_visitBG"] = 'G';
            } else {
              f[f.dc_team_id + "_" + v.key + "_visit"] = "";
              f[f.dc_team_id + "_" + v.key + "_visitBG"] = "";
            }
          });

          let dic = calToPayList_dic[f.dc_team_id] || {};
          //let total_netamt = calToPayList_dic[f.dc_team_id]?.total_netamt || 0;
          f.status_green1 = planDetailAll_dic[f.dc_team_id]?.length || 0;
          f.dc_net_amount = dic?.total_netamt || 0;
          f.total_wage = dic?.sum_wage || 0
          f.total_wage_tax = dic?.tax_amount || 0;
          f.total_exp_tax = dic?.sum_exp_tax || 0;
          f.total_amt_tax = dic?.sum_all_tax || 0;
          f.total_amt_net = dic?.labour_net_amount || 0;

        });

        this.ontotalSum()
        this.Getpage()

        if (wh_g) {
          this.createpay();
        } else {
          this.createtable();
        }
      },

      createtable() {
        this.dataList.forEach((value, index) => {
          var amt_n = [];
          var select_n = [];
          var day_n = [];
          this.columnsH.day.forEach((v, i) => {
            var key_spit = v.key.split("_");
            var date_i = this.dataH.daymaxpay
              ? this.dataH.daymaxpay
              : moment(this.dataH.dc_job_start_date, "DD-MM-YYYY").add(
                -1,
                "days"
              );

            var key_spit = v.key.split("_");
            var old =
              $linq(value.old || [])
                .where(x => x.date == key_spit[1])
                .firstOrDefault() || false;
            if (old) {
              amt_n.push({ value: old.amt });
              select_n.push({ value: old.select });
              day_n.push({ value: old.date });
              this.$set(value, v.key, old.select);
            } else {
              amt_n.push({ value: "N" });
              select_n.push({ value: "N" });
              day_n.push({ value: key_spit[1] });
              this.$set(value, v.key, "N");
            }
          });

          var dc_startend_days =
            $linq(amt_n || [])
              .select(x => x.value)
              .toArray()
              .join(",") || "";

          let day_ = value.dc_days || 0 ? value.dc_days : 0;

          this.$set(value, "dc_startend_days", dc_startend_days);

          this.$set(
            value,
            "dc_days_plan",
            value.dc_days_plan || "" ? value.dc_days_plan : 0
          );

          this.$set(
            value,
            "dc_currency",
            value.dc_currency || "" ? value.dc_currency : ""
          );

          this.$set(
            value,
            "dc_amount",
            value.dc_amount || "" ? value.dc_amount : 0
          );

          this.$set(
            value,
            "dc_cut_amount",
            value.dc_cut_amount || "" ? value.dc_cut_amount : 0
          );

          this.$set(
            value,
            "dc_wht_code",
            value.dc_wht_code || "" ? value.dc_wht_code : ""
          );

          var labour_amt_vat =
            $linq(this.expDataD || [])
              .where(
                x =>
                  x.dc_code == value.dc_team_id &&
                  x.dc_itemno_ref == value.dc_itemno &&
                  x.exp_type == 1
              )
              .sum(x => parseFloat(x.tax_amount)) || 0;

          var exp_amt_vat =
            $linq(this.expDataD || [])
              .where(
                x =>
                  x.dc_code == value.dc_team_id &&
                  x.dc_itemno_ref == value.dc_itemno &&
                  x.exp_type == 2
              )
              .sum(x => parseFloat(x.tax_amount)) || 0;

          var exp_labour_amt_vat = labour_amt_vat + exp_amt_vat;
          this.$set(value, "dc_wht_amount", exp_labour_amt_vat);
          this.$set(
            value,
            "dc_total_amount",
            value.dc_total_amount || "" ? value.dc_total_amount : 0
          );
        });

        this.dataH.dc_job_start_date = moment(
          this.minDate,
          "YYYY-MM-DD"
        ).toDate();
        this.dataH.dc_job_end_date = moment(this.maxDate, "YYYY-MM-DD").toDate();
        this.genReport("pay");
        this.Getpage();
        this.ontotalSum();
      },

      createpay() {
        this.totalBT.dc_tax_amount = $linq(this.dataList || []).sum(x => parseFloat(x.dc_net_amount)) || 0;
        this.totalBT.dc_net_amount = $linq(this.dataList || []).sum(x => parseFloat(x.dc_net_amount)) || 0;

        this.totalBT.dc_panding_days = $linq(this.dataList || []).sum(x => parseFloat(x.dc_panding_days)) || 0;
        this.totalBT.dc_duct_days = $linq(this.dataList || []).sum(x => parseFloat(x.dc_duct_days)) || 0;
        this.totalBT.dc_RP_days = $linq(this.dataList || []).sum(x => parseFloat(x.dc_RP_days)) || 0;
        this.totalBT.dc_total_day = $linq(this.dataList || []).sum(x => parseFloat(x.dc_total_day)) || 0;
        this.totalBT.dc_total_plan = $linq(this.dataList || []).sum(x => parseFloat(x.dc_total_plan)) || 0;
        this.totalBT.dc_tatal_diff = $linq(this.dataList || []).sum(x => parseFloat(x.dc_tatal_diff)) || 0;
        this.totalBT.dc_deduct_amt = $linq(this.dataList || []).sum(x => parseFloat(x.dc_deduct_amt)) || 0;
        this.totalBT.dc_labour_amount2 = $linq(this.dataList || []).sum(x => parseFloat(x.dc_labour_amount2)) || 0;
        this.totalBT.dc_amt_deduct = $linq(this.dataList || []).sum(x => parseFloat(x.dc_amt_deduct)) || 0;

        this.totalBT.total_amt_net = $linq(this.dataList || []).sum(x => parseFloat(x.total_amt_net)) || 0;

        this.expData.forEach((v, i) => {
          var ex_sum =
            $linq(this.dataList || []).sum(x => parseFloat(x[v.expens_code])) ||
            0;
          this.$set(this.totalBT, v.expens_code, ex_sum);
        });

        this.loading = false;
        this.ontotalSum();
        this.$set(this, "loadingx", false);
      },

      async onloadjob(pre_event) {
        // โหลด Job
        let data = await xtools.getServer(
          "AccountingforLabor/Master/job_Items_Read?pre_event=" + pre_event
        );
        this.jobData = data.data || [];
      },

      async onHoliday() {
        // โหลด account
        let data = await xtools.getServer(
          "AccountingforLabor/Master/holiday_Items_Read"
        );
        this.holidayData = data.data || [];
      },

      async onLoadmainName() {
        let data = await xtools.getServer(
          `Api/Public/LoginCompanies`
        );
        this.company = $linq(data.data).where(w => w.maincode == 'MG1').firstOrDefault();
      },

      async onloadprcontrol(prno, costcode) {
        let data = await xtools.getServer(
          "AccountingforLabor/Master/onloadprcontrol?prno=" +
          prno +
          "&costcode=" +
          costcode
        );
        this.objcontron = data.data.data.length
          ? data.data.data[0]
          : { costcode: "", qty_control: "", amt_control: "" };
      },

      async onloadprcontrollist(prno, costcode) {
        // โหลด account
        let data = await xtools.getServer(
          "AccountingforLabor/Master/onloadprcontrollist_bal?prno=" +
          prno +
          "&costcode=" +
          costcode +
          "&dc_docno=" +
          this.dataH.dc_docno_ref
        );
        this.objcontronlist = data.data.data;
        var costcode = "";
        this.objcontronlist.forEach((v, i) => {
          var countRow = $linq(this.objcontronlist).where(x => x.costcode == v.costcode).count();
          var qty_total_sum = $linq(this.objcontronlist).where(x => x.costcode == v.costcode).sum(x => parseFloat(x.qty_control));
          var total_sum = $linq(this.objcontronlist).where(x => x.costcode == v.costcode).sum(x => parseFloat(x.amt_control));
          v.amt_bal = (v.amt_bal || v.amt_ex_bal);

          if (costcode != v.costcode) {
            this.$set(v, 'rowpan', countRow);
            this.$set(v, 'qty_total', qty_total_sum);
            this.$set(v, 'amt_total', total_sum);
            costcode = v.costcode;
          } else {
            this.$set(v, 'rowpan', 0);
            costcode = v.costcode;
            this.$set(v, 'qty_total', qty_total_sum);
            this.$set(v, 'amt_total', total_sum);
          }

        })
      },

      async loadpaylistbydocno(docno) {
        // โหลด account
        let data = await xtools.getServer(
          "AccountingforLabor/Master/loadpaylistbydocno?docno=" + docno
        );
        this.paylistbydocno = data.data.data;
      },

      async SavePlanY() {
        // บันทึก  PlanY
        if (this.menuRight.isreadonly == 1) {
          return;
        }

        if (this.dataH.dc_remark == "") {
          this.$notify("error filled", "Message System", "กรุณากรอก Remark ", {
            duration: 8000,
            permanent: false
          });
          return false;
        }

        var get_y = $linq(this.planDetailAll).any(a => (a.visit_status == "Y" || a.visit_status == "YS"))

        if (get_y) {
          this.$notify("error filled", "Message System", "พบสถานะ Y หรือ Y(SH) ไม่สามารถบันทึกข้อมูลทำจ่ายได้", {
            duration: 8000,
            permanent: false
          });
          return false;
        }

        var min = moment(this.minDate, "YYYY-MM-DD");
        var set = moment(this.dataH.dc_job_start_date, "YYYY-MM-DD");
        var diff_date = moment.duration(min.diff(set)).asDays();

        if (diff_date != 0) {
          this.$notify("error filled", "Message System", "ไม่สามารถบันทึกข้อมูลทำจ่ายได้ เนื่องจาก Start Date ไม่ถูกต้อง", {
            duration: 8000,
            permanent: false
          });
          return false;
        }

        var maxpayday = moment(this.dataH.daymaxpay, "YYYY-MM-DD");
        var endplanday = moment(this.dataH.dc_job_end_date, "YYYY-MM-DD");
        var diff_days = moment.duration(maxpayday.diff(endplanday)).asDays();

        if (diff_days == 0) {
          this.$notify("error filled", "Message System", "ไม่สามารถบันทึกข้อมูลทำจ่ายได้ เนื่องจาก Plan นี้มีการทำจ่ายจนถึงวันสิ้นสุด Plan แล้ว", {
            duration: 8000,
            permanent: false
          });
          return false;
        }

        this.$set(this, "export_progress", "กำลังบันทึกข้อมูลทำจ่าย กรุณารอจนกว่ากระบวนการเสร็จสิ้น");
        this.$set(this, "loadingx", true);

        let dataSave = [];
        this.dataH.dc_job_code = this.dataH.dc_job_name2.value;
        this.dataH.dc_job_name = this.dataH.dc_job_name2.label;
        this.dataH.type_doc = 4;

        if (this.minDate) {
          this.dataH.dc_job_start_date = this.minDate;
        }

        this.dataList.forEach((v, i) => {
          let tax_amount_labour = (this.ondecimal(v.dc_net_amount || 0) * this.ondecimal(this.dataH.taxper || 0)) / 100 || 0;
          let net_amount_labour = this.ondecimal(v.dc_net_amount || 0) - this.ondecimal(tax_amount_labour);

          if (v.dc_net_amount) {
            dataSave.push({
              dc_docno: v.dc_docno || "",
              dc_itemno: null,
              dc_docno_ref: this.dataH.dc_docno_ref,
              dc_itemno_ref: v.dc_itemno,
              code: this.dataH.exp_labour,
              amount: this.ondecimal(v.dc_net_amount),
              tax_per: this.ondecimal(this.dataH.taxper),
              tax_amount: this.ondecimal(tax_amount_labour),
              net_amount: this.ondecimal(net_amount_labour),
              dc_code: v.dc_team_id,
              costcode: this.dataH.costcode,
              exp_type: 1, // 1 = Labour  2 = Exp
              duct_amount: this.ondecimal(v.duct_amount),
              day_pay: v.status_green1,
              deduct_amt: this.ondecimal(v.dc_deduct_amt),
              wage_amt: this.ondecimal(v.dc_labour_amount2),
              deduct_wages_amt: this.ondecimal(v.dc_amt_deduct)
            });
          }

          this.expData.forEach((v2, i2) => {
            let tax_amount_exp =
              (this.ondecimal(v[v2.expens_code] || 0) * this.ondecimal(v2.taxper || 0)) /
              100 || 0;
            let net_amount_exp =
              this.ondecimal(v[v2.expens_code] || 0) - this.ondecimal(tax_amount_exp);

            if (v[v2.expens_code]) {
              dataSave.push({
                dc_docno: v.dc_docno || "",
                dc_itemno: null,
                dc_docno_ref: this.dataH.dc_docno_ref,
                dc_itemno_ref: v.dc_itemno,
                code: v2.expens_code,
                amount: this.ondecimal(v[v2.expens_code]),
                tax_per: this.ondecimal(v2.taxper),
                tax_amount: this.ondecimal(tax_amount_exp),
                net_amount: this.ondecimal(net_amount_exp),
                dc_code: v.dc_team_id,
                costcode: v2.costcode,
                exp_type: 2, // 1 = Labour  2 = Exp
                duct_amount: 0,
                day_pay: 0,
                deduct_amt: 0,
                wage_amt: 0,
                deduct_wages_amt: 0
              });
            }
          });
        });

        this.minPaidDate = moment(this.dataH.dc_job_end_date, "YYYY-MM-DD")
          .add(1, "days")
          .toDate();

        this.dataH.amount =
          $linq(dataSave || []).sum(x => parseFloat(x.amount)) || 0;
        this.dataH.tax_amount =
          $linq(dataSave || []).sum(x => parseFloat(x.tax_amount)) || 0;
        this.dataH.net_amount =
          $linq(dataSave || []).sum(x => parseFloat(x.net_amount)) || 0;

        this.dataH.day_amt = this.dataList[0].dc_deduct_amt;
        var data = await xtools.postServerJson(
          "AccountingforLabor/Transaction/createpaylabour",
          { dataH: this.dataH, dataD: dataSave }
        );
        if (data.success == true) {
          xtools.onSaveActionLogs(this.$route.meta.module, this.$route.meta.nameMenu + " [Save]", this.dataH.dc_docno_ref);
          this.$notify(
            "success filled",
            "Message System",
            "Save data successfully.",
            { duration: 3000, permanent: false }
          );
          this.onloadLabourByDate(this.dataH.dc_docno_ref, this.minPaidDate, this.date_old.end);
        } else {
          this.$notify("error filled", "Message System", "Failed to save data.", {
            duration: 3000,
            permanent: false
          });
        }
        this.$set(this, "loadingx", false);
      },

      async onDeletePay(v) {
        if (this.menuRight.isreadonly == 1) { return; }

        this.loading = true;
        let data = await xtools.getServer(
          "AccountingforLabor/Transaction/deletePay?dc_docno=" + v.dc_docno
        );
        if (data.success == true) {

          xtools.onSaveActionLogs(this.$route.meta.module, this.$route.meta.nameMenu + " [Delete Labour To pay List]", v.dc_docno);

          this.loading = false;
          this.$notify(
            "success filled",
            "Message System",
            "Delete data successfully.",
            { duration: 3000, permanent: false }
          );
          this.onloadLabourByDate(this.dataH.dc_docno_ref, v.dc_job_start_date, this.dataH.dc_job_end_date);
        } else {
          this.loading = false;
          this.$notify("error filled", "Message System", data.error, {
            duration: 3000,
            permanent: false
          });
        }
      },

      /* Add Style Function */
      hidyColor(v) {
        if (v == 1) {
          return "background-color:#e65100 !important;";
        } else {
          return "background-color:#FFF !important;";
        }
      },

      getkeyname(key) {
        var cl = key.split("_");
        //v.calculate =
        if (cl.length == 2) {
          return cl[0] + "" + cl[1];
        } else {
          return key;
        }
      },

      rowcolor(v) {

        this.detailList.forEach((v2, i) => {
          if (v.dc_itemno == v2.dc_itemno) {
            this.$set(v2, 'slectrow', "selected");
          } else {
            this.$set(v2, 'slectrow', "");
          }
        })
      },

      /* Sub Function */
      getformula() {
        if (this.dataH.type_doc == 1) {
          return 1;
        }
        if (this.columnsH.day.length == 28) {
          return 2;
        }
        if (this.columnsH.day.length == 29) {
          return 2;
        }
        if (this.columnsH.day.length == 30) {
          return 2;
        }
        if (this.columnsH.day.length == 31) {
          return 2;
        }

        return 1;
      },

      onkeypressValue(v, vv) {
        var ex_paytrue = $linq(this.paylistbydocno).where(x => x.costcode == vv.costcode && x.dc_docno != v.dc_docno).sum(x => parseFloat(x.amount)) || 0;
        var ex_code = $linq(this.expData).where(x => x.costcode == vv.costcode).select(x => x.expens_code).toArray();
        var ex_contron = 0;
        this.objcontronlist.forEach(e => {
          if (e.costcode == vv.costcode) {
            ex_contron = parseFloat(ex_contron) + parseFloat(e.amt_control)
          }
        });

        var ex_cur = 0;

        this.dataList.forEach(cost => {
          ex_code.forEach(ex => {
            ex_cur = parseFloat(ex_cur) + (parseFloat(cost[ex]) || 0);
          });
        });

        var excut_amt = parseFloat(ex_contron) - (parseFloat(ex_paytrue) || 0) || 0;

        if (ex_cur > excut_amt) {
          alert("จำนวนเงินเกิน ควบคุม");
          v[vv.expens_code] = 0;
          return false;
        }

        if (this.dataH.type_doc == "1") {
          let dc_amount = (v.dc_labour_amount || 0) * (v.dc_days || 0);
          this.$set(v, "dc_amount", dc_amount);
          var sum_m = 0;
          this.columnsH.day.forEach((vv, ii) => {
            if (v[vv.key] == "1" || v[vv.key] == "0.5" || v[vv.key] == "S3") {
              sum_m = sum_m + parseFloat(v[vv.key] == "S3" ? 1 : v[vv.key]);
            }
          });

          let dc_net_amount =
            (v.dc_labour_amount || 0) *
            (sum_m +
              parseInt(v.dc_hid_days) * parseInt(this.dataH.labour_plus) || 0) +
            (v.dc_cut_amount || 0);

          let dc_wht_amount =
            (((v.dc_labour_amount || 0) * (v.dc_days || 0) +
              (v.dc_cut_amount || 0)) /
              100) *
            3;
          this.$set(v, "dc_wht_amount", this.ondecimal(dc_wht_amount));

          let dc_total_amount = this.ondecimal(dc_net_amount) - this.ondecimal(dc_wht_amount);
          this.$set(v, "dc_total_amount", this.ondecimal(dc_total_amount));

          var ex_count = 0;
          this.expData.forEach((ex, iex) => {
            ex_count = ex_count + v[ex.expens_code] || 0;
          });
          this.$set(v, "total_amt_net", this.ondecimal(ex_count) + this.ondecimal(dc_total_amount));
        }

        if (this.dataH.type_doc == "2") {

          var ex_count = 0;
          this.expData.forEach((ex, iex) => {
            ex_count = parseFloat(ex_count) + parseFloat(v[ex.expens_code] || 0);
          });
          this.$set(v, "total_amt_net", this.ondecimal(ex_count) + this.ondecimal(v.dc_net_amount));
        }

        var exp_amt = 0;
        var exp_amt_ex = 0;
        this.expData.forEach((v2, i2) => {
          exp_amt = parseFloat(exp_amt || 0) + parseFloat(v[v2.expens_code] || 0);
          let tax_amount_exp = (parseFloat(v[v2.expens_code] || 0) * parseFloat(v2.taxper || 0)) / 100 || 0;

          exp_amt_ex = parseFloat(exp_amt_ex) + parseFloat(tax_amount_exp);

        });
        var total_wage_ex = this.ondecimal(v.dc_net_amount) + this.ondecimal(exp_amt)
        this.$set(v, "total_wage", this.ondecimal(total_wage_ex));
        this.$set(v, "total_exp_tax", this.ondecimal(exp_amt_ex))

        var total_amt_tax = this.ondecimal(v.total_wage_tax) + this.ondecimal(exp_amt_ex);
        this.$set(v, "total_amt_tax", this.ondecimal(total_amt_tax));

        var total_amt_net = this.ondecimal(total_wage_ex) - this.ondecimal(total_amt_tax);
        this.$set(v, "total_amt_net", this.ondecimal(total_amt_net));

        this.ontotalSum();
      },

      ontotalSum() {

        let sum_labour_amount =
          this.dataList.reduce((sum, x) => this.ondecimal(sum + this.ondecimal(x.dc_labour_amount)), 0) || 0;
        this.$set(this.totalBT, "dc_labour_amount", sum_labour_amount);

        let sum_visit =
          this.dataList.reduce((sum, x) => this.ondecimal(sum + this.ondecimal(x.plan_visit)), 0) || 0;
        this.$set(this.totalBT, "plan_visit", sum_visit);

        let sum_green1 =
          this.dataList.reduce((sum, x) => this.ondecimal(sum + this.ondecimal(x.status_green1)), 0) || 0;
        this.$set(this.totalBT, "status_green1", sum_green1);

        let sum_net_amt =
          $linq(this.calToPayList || []).select(s => this.ondecimal(s.sum_total_netamt)).firstOrDefault() || 0;
        this.$set(this.totalBT, "dc_net_amount", sum_net_amt);

        let sum_total_wage =
          this.dataList.reduce((sum, x) => this.ondecimal(sum + this.ondecimal(x.total_wage)), 0) || 0;
        this.$set(this.totalBT, "total_wage", sum_total_wage);

        let sum_wage_tax =
          $linq(this.calToPayList || []).select(s => this.ondecimal(s.total_tax_amount)).firstOrDefault() || 0;
        this.$set(this.totalBT, "total_wage_tax", sum_wage_tax);

        let sum_exp_tax =
          this.dataList.reduce((sum, x) => this.ondecimal(sum + this.ondecimal(x.total_exp_tax)), 0) || 0;
        this.$set(this.totalBT, "total_exp_tax", sum_exp_tax);

        let sum_amt_tax =
          this.dataList.reduce((sum, x) => this.ondecimal(sum + this.ondecimal(x.total_amt_tax)), 0) || 0;
        this.$set(this.totalBT, "total_amt_tax", sum_amt_tax);

        let sum_amt_net =
          this.dataList.reduce((sum, x) => this.ondecimal(sum + this.ondecimal(x.total_amt_net)), 0) || 0;
        this.$set(this.totalBT, "total_amt_net", sum_amt_net);

        this.expData.forEach((v, i) => {
          var ex_sum =
            this.dataList.reduce((sum, x) => this.ondecimal(sum + this.ondecimal(x[v.expens_code])), 0) || 0;
          this.$set(this.totalBT, v.expens_code, ex_sum);
        });
      },

      getDeffDate(start, end) {
        const date1 = moment(start).toDate(); //new Date('7/13/2010');
        const date2 = moment(end).toDate();//new Date('12/15/2010');
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays + 1;
      },

      onsetValue(val) {
        this.setval = val;
      },

      hideExport(tabIndex) {
        if (tabIndex == 0) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      },

      ondecimal(amount) {
        if (parseFloat(amount)) {
          return new Decimal(parseFloat(amount)).toDP(6).toDP(2).toNumber()
        } else {
          return 0
        }
      },

      DateCh: function (date) {
        return date ? moment(date, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
      },

      getDateRange(startDate, endDate, dateFormat, arr) {
        var dates = [],
          end = moment(endDate).add(1, 'days');
        var diff = (endDate.diff(startDate, 'days') + 1);
        if (!startDate.isValid() || !endDate.isValid() || diff <= 0) {
          return;
        }
        for (var i = 0; i < diff; i++) {
          var vv = end.subtract(1, 'd').format(dateFormat)
          var obj = $linq(arr || []).where(x => moment(x.detecheck).format('YYYY-MM-DD') == vv).firstOrDefault() || null;
          if (obj != null) {
            dates.push(
              {
                "date": vv,
                detecheck: this.DateCh(obj.detecheck),
                dc_account_name: obj.dc_account_name,
                dc_province_name: obj.dc_province_name,
                dc_store_name: obj.dc_store_name,
                dc_time_checkin: obj.time_checkin,
                dc_time_checkout: obj.time_checkout,
                dc_checker: obj.dc_user_control_name,
                status: true
              }
            );
          } else {
            dates.push({ "date": vv, dc_account_name: "", dc_province_name: "", dc_store_name: "", dc_time_checkin: "", dc_time_checkout: "", dc_checker: "", status: false });
          }

        }
        return dates;
      },

      /* Import & Export */
      async importExcelTopay(exeel) {
        var form = new FormData()
        form.append('search', "")
        form.append('search', "")
        form.append('skip', 0)
        form.append('take', 200)
        let dataEx = await xtools.postServerForm('AccountingforLabor/Master/expensother_Items_Read', form);
        var statusControl = false;
        this.expData = [];
        this.dataimport = [];
        readXlsxFile(exeel.files[0]).then((rows) => {
          //var ex_paytrue = $linq(this.paylistbydocno).where(x => x.costcode == vv.costcode && x.dc_docno != v.dc_docno).sum(x => parseFloat(x.amount)) || 0;
          var excelData = rows;
          var ex_controlArr = [];
          var ix = 9;
          for (ix; ix < rows[0].length; ix++) {
            let v_ = $linq(dataEx.data.data).where(x => rows[1][ix] == x.expens_code).firstOrDefault() || null;
            this.expData.push({ costcode: rows[0][ix], expens_code: rows[1][ix], expens_name: rows[2][ix], exptype: 2, ix: ix, taxper: v_.taxper });

            var ex_paytrue = $linq(this.paylistbydocno).where(x => x.costcode == rows[0][ix]).sum(x => this.ondecimal(x.amount)) || 0;
            var costcodeControl = $linq(this.objcontronlist).where(x => x.costcode == rows[0][ix]).sum(x => this.ondecimal(x.amt_control)) || 0;
            ex_controlArr.push(
              {
                expens_name: rows[2][ix],
                costcode: rows[0][ix],
                expens_code: rows[1][ix],
                control_ex_df: costcodeControl,
                control_ex_pay: ex_paytrue,
                ex_cut: (costcodeControl - ex_paytrue),
                ex_inport: 0,
                ix: ix
              });
          }

          excelData.forEach((v, i) => {
            if (i > 2) {
              this.dataimport.push(v);
            }
          })
          ex_controlArr.forEach((v, i) => {
            var ex_count = 0;
            this.dataimport.forEach((vv, ii) => {
              ex_count = this.ondecimal(ex_count) + this.ondecimal(vv[v.ix] || 0)
            })
            v.statusControl = (this.ondecimal(v.ex_cut) < this.ondecimal(ex_count)) ? true : false;
            v.ex_inport = ex_count;

          })

          var gruopControl = $linq(ex_controlArr).groupBy(gg => gg.costcode).select(s =>   //  **************** group month
          {
            return {
              control_ex_pay: $linq(s.values).sum(x => parseFloat(x.control_ex_pay)),
              ex_cut: s.values[0].ex_cut,
              ex_inport: $linq(s.values).sum(x => parseFloat(x.ex_inport)),
              statusControl: (s.values[0].ex_cut < $linq(s.values).sum(x => parseFloat(x.ex_inport))) ? true : false,
              costcode: s.values[0].costcode,

            }
          }).toArray()

          var countS = $linq(gruopControl).where(x => x.statusControl).count() || 0;
          if (countS) {
            alert("ค่าใช้จ่าย Expenses เกินจำนวนที่ Control ");
            this.expData = [];
            return;
          }

          this.dataList.forEach((v, i) => {
            var exp_amt = 0;
            var exp_amt_ex = 0;
            this.expData.forEach((v2, i2) => {
              let v_exp = $linq(excelData).where(x => v.item_sort == x[0] && v.dc_docno == x[1] && v.dc_team_id == x[5]).firstOrDefault() || null;
              if (v_exp != null) {
                exp_amt = this.ondecimal(exp_amt || 0) + this.ondecimal(v_exp[v2.ix] || 0);
                let tax_amount_exp = (this.ondecimal(v_exp[v2.ix] || 0) * this.ondecimal(v2.taxper || 0)) / 100 || 0;
                exp_amt_ex = this.ondecimal(exp_amt_ex) + this.ondecimal(tax_amount_exp);
                this.$set(v, v2.expens_code, v_exp[v2.ix]);
              }
            });

            var total_wage_ex = this.ondecimal(v.dc_net_amount) + this.ondecimal(exp_amt);
            this.$set(v, "total_wage", total_wage_ex);

            this.$set(v, "total_exp_tax", exp_amt_ex)

            var total_amt_tax = this.ondecimal(v.total_wage_tax) + this.ondecimal(exp_amt_ex);
            this.$set(v, "total_amt_tax", total_amt_tax);

            var total_amt_net = this.ondecimal(total_wage_ex) - this.ondecimal(total_amt_tax);
            this.$set(v, "total_amt_net", total_amt_net);

          });
          this.ontotalSum();
        })

      },

      async exportToExcel() {
        if (!await $msg.confirm(`การ Export ข้อมูลอาจใช้เวลานานหากมีข้อมูลจำนวนมาก กรุณายืนยันการทำรายการ`)) {
          return;
        }
        this.$set(this, "export_progress", "กำลังสร้างรายงาน กรุณารอจนกว่ากระบวนการเสร็จสิ้น");
        this.$set(this, "loadingx", true);

        let startdate = moment(this.dataH.dc_job_start_date).format('YYYY-MM-DD')
        let enddate = moment(this.dataH.dc_job_end_date).format('YYYY-MM-DD')

        let act = 'AccountingforLabor/Transaction/LabourShareServiceToPayExportExcel?docno=' + this.dataH.dc_docno_ref + '&startdate=' + startdate + '&enddate=' + enddate;
        let rsp = await xtools.postServerJson(act);
        window.open(window.serverUrl + `API/File/DownLoad?download=true&id=${rsp.data}`);

        this.$set(this, "loadingx", false);

        xtools.onSaveActionLogs(
          this.$route.meta.module,
          this.$route.meta.nameMenu + " [Export Labour Share Service To Pay]",
          this.dataList[0].dc_docno
        );
      },

      async onExOutsource2(val) {
        let data = await xtools.getServer("AccountingforLabor/Transaction/checklistOutsourceExportExcel?dc_code=" + val.dc_docno_ref + "&dc_paycode=" + val.dc_docno + "&startdate=" + moment(val.dc_job_start_date).format("YYYY/MM/DD") + "&enddate=" + moment(val.dc_job_end_date).format("YYYY/MM/DD"));

        xtools.onSaveActionLogs(this.$route.meta.module, this.$route.meta.nameMenu + " [รายงานการทำงาน Outsource]", val.dc_docno);

        var dataexport = data.data.dt;
        var pay_list = data.data.pay_list;
        var labour_list = data.data.labour_list;
        var start_date = data.data.start_date;
        var end_date = data.data.end_date;

        const wb = new ExcelJS.Workbook();
        dataexport.forEach((v, i) => {
          let worksheet = wb.addWorksheet((i + 1) + ") " + (v.dc_team_id_name).toString() + "(" + v.dc_team_id.toString() + ")");
          var columnsF = [
            { header: '', key: 'working_date', width: 15 },
            { header: '', key: 'province_name', width: 25 },
            { header: '', key: 'area_name', width: 20 },
            { header: '', key: 'part_name', width: 20 },
            { header: '', key: 'store_name', width: 30 },
            { header: '', key: 'time_checkin', width: 20 },
            { header: '', key: 'time_checkout', width: 20 },
            { header: '', key: 'quo_no', width: 20 },
            { header: '', key: 'brand_name', width: 20 },
            { header: '', key: 'time_callcard', width: 30 },
            { header: '', key: 'dc_user_control_name', width: 30 }
          ];
          worksheet.columns = columnsF;

          worksheet.mergeCells('A1:K1');
          worksheet.getCell('A1').value = this.company.mainname;
          worksheet.getCell('A1').alignment = { horizontal: 'center' };
          worksheet.getCell('A1').font = { color: { argb: "000" }, size: 16, bold: true };
          worksheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.mergeCells('A2:K2');
          worksheet.getCell('A2').value = 'รายงานการทำงาน Outsource';
          worksheet.getCell('A2').alignment = { horizontal: 'center' };
          worksheet.getCell('A2').font = { color: { argb: "000" }, size: 14, bold: true };
          worksheet.getCell('A2').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getRow(3).values = ["ชื่อ-นามสกุล : ", v.dc_team_id_name + "(" + v.dc_team_id + ")", "", "", "", "", "เลขบัตรประชาชน : ", v.dc_id_card, "", "", ""];
          worksheet.getRow(4).values = ["ตำแหน่ง : ", v.dc_position_name, "", "", "", "", "เบอร์โทรติดต่อ : ", v.dc_phone, "", "", ""];
          worksheet.getRow(5).values = ["Project : ", this.dataH.dc_project_name, "", "", "ประเภท Plan : Share Service", "", "", "", "", "", "Ref Code : " + this.dataH.refcode];

          worksheet.getCell('A5').font = { color: { argb: "000" } };
          worksheet.getCell('A5').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.mergeCells('B5:D5');
          worksheet.mergeCells('E5:I5');
          worksheet.getCell('D5').font = { color: { argb: "000" } };
          worksheet.getCell('D5').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('F5').font = { color: { argb: "000" } };
          worksheet.getCell('F5').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };
          worksheet.getCell('G5').font = { color: { argb: "000" } };
          worksheet.getCell('G5').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('H5').font = { color: { argb: "000" } };
          worksheet.getCell('H5').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('I5').font = { color: { argb: "000" } };
          worksheet.getCell('I5').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('J5').font = { color: { argb: "000" } };
          worksheet.getCell('J5').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('K5').font = { color: { argb: "000" } };
          worksheet.getCell('K5').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.mergeCells('A6:B6');
          worksheet.getCell('B6').value = 'Job Type : ' + this.dataH.dc_job_name;
          worksheet.getCell('B6').font = { color: { argb: "000" } };
          worksheet.getCell('B6').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.mergeCells('C6:D6');
          worksheet.getCell('D6').value = 'Period : ' + this.DateCh(start_date) + " - " + this.DateCh(end_date);
          worksheet.getCell('D6').font = { color: { argb: "000" } };
          worksheet.getCell('D6').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.mergeCells('E6:I6');
          worksheet.getCell('I6').value = 'Document No : ' + this.dataH.dc_docno_ref;
          worksheet.getCell('I6').font = { color: { argb: "000" } };
          worksheet.getCell('I6').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('J6').font = { color: { argb: "000" } };
          worksheet.getCell('J6').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('K6').value = 'Pay List No : ' + val.dc_docno;
          worksheet.getCell('K6').font = { color: { argb: "000" } };
          worksheet.getCell('K6').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };
          worksheet.getCell('A7').value = "D/M/Y";
          worksheet.getCell('B7').value = "Province";
          worksheet.getCell('C7').value = "Store (เขต)";
          worksheet.getCell('D7').value = "Location (ภาค)";
          worksheet.getCell('E7').value = "Store";
          worksheet.getCell('F7').value = "Store (Check-In)";
          worksheet.getCell('G7').value = "Store (Check-Out)";
          worksheet.getCell('H7').value = "QT";
          worksheet.getCell('I7').value = "Brand";
          worksheet.getCell('J7').value = "Call Card (Check-In)";
          worksheet.getCell('K7').value = "Checker";

          worksheet.getCell('A7').alignment = { horizontal: 'center' };
          worksheet.getCell('A7').font = { color: { argb: "000" }, size: 12, bold: true };
          worksheet.getCell('A7').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('B7').alignment = { horizontal: 'center' };
          worksheet.getCell('B7').font = { color: { argb: "000" }, size: 12, bold: true };
          worksheet.getCell('B7').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('C7').alignment = { horizontal: 'center' };
          worksheet.getCell('C7').font = { color: { argb: "000" }, size: 12, bold: true };
          worksheet.getCell('C7').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('D7').alignment = { horizontal: 'center' };
          worksheet.getCell('D7').font = { color: { argb: "000" }, size: 12, bold: true };
          worksheet.getCell('D7').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('E7').alignment = { horizontal: 'center' };
          worksheet.getCell('E7').font = { color: { argb: "000" }, size: 12, bold: true };
          worksheet.getCell('E7').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('F7').alignment = { horizontal: 'center' };
          worksheet.getCell('F7').font = { color: { argb: "000" }, size: 12, bold: true };
          worksheet.getCell('F7').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('G7').alignment = { horizontal: 'center' };
          worksheet.getCell('G7').font = { color: { argb: "000" }, size: 12, bold: true };
          worksheet.getCell('G7').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('H7').alignment = { horizontal: 'center' };
          worksheet.getCell('H7').font = { color: { argb: "000" }, size: 12, bold: true };
          worksheet.getCell('H7').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('I7').alignment = { horizontal: 'center' };
          worksheet.getCell('I7').font = { color: { argb: "000" }, size: 12, bold: true };
          worksheet.getCell('I7').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('J7').alignment = { horizontal: 'center' };
          worksheet.getCell('J7').font = { color: { argb: "000" }, size: 12, bold: true };
          worksheet.getCell('J7').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          worksheet.getCell('K7').alignment = { horizontal: 'center' };
          worksheet.getCell('K7').font = { color: { argb: "000" }, size: 12, bold: true };
          worksheet.getCell('K7').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e6e6e6' },
            bgColor: { argb: 'e6e6e6' }
          };

          var pay_obj = $linq(pay_list || []).where(x => x.dc_itemno_ref == v.dc_itemno && x.exp_type == "1").firstOrDefault() || null;

          let row_ = 7;

          v.chklist.forEach(v2 => {
            var detail = [this.DateCh(v2.working_date), v2.province_name, v2.area_name, v2.part_name, v2.store_name, v2.time_checkin, v2.time_checkout, v2.quo_no, v2.brand_name, v2.time_callcard, v.dc_user_control_name];
            worksheet.addRow(detail);
            row_++;
          })
          worksheet.state = 'visible';
        });
        const buf = await wb.xlsx.writeBuffer();
        saveAs(new Blob([buf]), "Outsource.xlsx");
      },

      async onExOutsource(val) {        
        if (!await $msg.confirm(`การ Export ข้อมูลอาจใช้เวลานานหากมีข้อมูลจำนวนมาก กรุณายืนยันการทำรายการ`)) {
          return;
        }
        this.$set(this, "export_progress", "กำลังสร้างรายงาน กรุณารอจนกว่ากระบวนการเสร็จสิ้น");
        this.$set(this, "loadingx", true);

        let startdate = moment(val.dc_job_start_date).format('YYYY-MM-DD')
        let enddate = moment(val.dc_job_end_date).format('YYYY-MM-DD')

        let act = 'AccountingforLabor/Transaction/checklistOutsourceExportExcel?docno=' + val.dc_docno_ref + '&dc_paycode=' + val.dc_docno + '&startdate=' + startdate + '&enddate=' + enddate;
        let rsp = await xtools.postServerJson(act);
        window.open(window.serverUrl + `API/File/DownLoad?download=true&id=${rsp.data}`);

        this.$set(this, "loadingx", false);

        xtools.onSaveActionLogs(
          this.$route.meta.module,
          this.$route.meta.nameMenu + " [Export Outsource Checklist Labour Share Service]",
          val.dc_docno
        );
      },

      async exportExpenseTopay() {
        if (this.menuRight.issaveas == 1) {
          return;
        }

        const wb = new ExcelJS.Workbook();
        const ws = wb.addWorksheet();
        var columnsF = [
          { header: 'Project : ' + this.dataH.dc_project_name, key: 'item_sort', width: 5 },
          { header: '', key: 'dc_docno', width: 20 },
          { header: '', key: 'part_name', width: 20 },
          { header: '', key: 'province_name', width: 20, },
          { header: '', key: 'area_name', width: 20, },
          { header: '', key: 'dc_team_id', width: 20 },
          { header: '', key: 'dc_team_id_name', width: 25 },
          { header: '', key: 'dc_position_name', width: 25 },
          { header: 'Costcode', key: 'status_green1', width: 15, }
        ];

        var columnsAdd = [];
        var columnsAdd2 = [];
        this.expData.forEach((v, i) => {
          columnsAdd.push({ header: v.costcode, key: v.expens_code, width: 15 })
          columnsAdd2.push(v.expens_code)
        });

        var col1 = ["Remark : " + this.dataH.dc_remark_ref, "Labour No : " + this.dataH.dc_docno_ref, "", "", "", "", "", "", "Expenses code"];
        var col2 = ["No", "Labour No", "ภาค", "จังหวัด", "เขต", "Outsource Code", "Outsource", "Position", "Actual Visit"];
        this.expData.forEach((v, i) => {
          col2.push(v.expens_name);
          ws.getRow(1).getCell(10 + i).font = { color: { argb: "333333" } };
          ws.getRow(1).getCell(10 + i).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ccffff' },
            bgColor: { argb: 'ccffff' }
          };
          ws.getRow(2).getCell(10 + i).font = { color: { argb: "333333" } };
          ws.getRow(2).getCell(10 + i).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ccffff' },
            bgColor: { argb: 'ccffff' }
          };
        });
        ws.getRow(2).values = col1.concat(columnsAdd2);
        ws.getRow(3).values = col2;

        ws.columns = columnsF.concat(columnsAdd)

        this.dataList.forEach((v, i) => {
          var val = {
            item_sort: v.item_sort,
            dc_docno: v.dc_docno,
            part_name: v.part_name,
            province_name: v.province_name,
            area_name: v.area_name,
            dc_team_id: v.dc_team_id,
            dc_team_id_name: v.dc_team_id_name,
            dc_position_name: v.dc_position_name,
            status_green1: v.status_green1
          };

          this.expData.forEach((v, i) => {
            val[v.expens_code] = 0;
          });

          ws.addRow(val);
          ws.getRow(i + 4).getCell(1).font = { color: { argb: "333333" } };
          ws.getRow(i + 4).getCell(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ccffff' },
            bgColor: { argb: 'ccffff' }
          };

          ws.getRow(i + 4).getCell(2).font = { color: { argb: "333333" } };
          ws.getRow(i + 4).getCell(2).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ccffff' },
            bgColor: { argb: 'ccffff' }
          };
          ws.getRow(i + 4).getCell(3).font = { color: { argb: "333333" } };
          ws.getRow(i + 4).getCell(3).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ccffff' },
            bgColor: { argb: 'ccffff' }
          };

          ws.getRow(i + 4).getCell(4).font = { color: { argb: "333333" } };
          ws.getRow(i + 4).getCell(4).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ccffff' },
            bgColor: { argb: 'ccffff' }
          };

          ws.getRow(i + 4).getCell(5).font = { color: { argb: "333333" } };
          ws.getRow(i + 4).getCell(5).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ccffff' },
            bgColor: { argb: 'ccffff' }
          };

          ws.getRow(i + 4).getCell(6).font = { color: { argb: "333333" } };
          ws.getRow(i + 4).getCell(6).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ccffff' },
            bgColor: { argb: 'ccffff' }
          };

          ws.getRow(i + 4).getCell(7).font = { color: { argb: "333333" } };
          ws.getRow(i + 4).getCell(7).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ccffff' },
            bgColor: { argb: 'ccffff' }
          };

          ws.getRow(i + 4).getCell(8).font = { color: { argb: "333333" } };
          ws.getRow(i + 4).getCell(8).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ccffff' },
            bgColor: { argb: 'ccffff' }
          };

          ws.getRow(i + 4).getCell(9).font = { color: { argb: "333333" } };
          ws.getRow(i + 4).getCell(9).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ccffff' },
            bgColor: { argb: 'ccffff' }
          };
        });

        ws.getRow(1).getCell(2).font = { color: { argb: "004e47cc" } };

        const buf = await wb.xlsx.writeBuffer();
        saveAs(new Blob([buf]), this.dataH.dc_docno_ref + ".xlsx");

        xtools.onSaveActionLogs(this.$route.meta.module, this.$route.meta.nameMenu + " [Export Expeness to Pay RO]", this.dataH.dc_docno_ref);
      },

      /* Paging */
      Getpage() {
        var skip = this.limitPage * this.page - this.limitPage || 0;
        this.skip = skip;
        this.detailList = $linq(this.dataList)
          .skip(skip)
          .take(this.limitPage)
          .toArray();
      },

      onrefPage() {
        this.perPage = Math.ceil(this.dataList.length % this.limitPage) < 1 ? 1 + 2 : this.dataList.length / this.limitPage + 2;
      },

      /* Center */
      async onModalReturn(e) {
        if (e.wh == "labour") {
          if(!xtools.isEmpty(e.data.maxpaydate)) {
            this.new_startday = moment(e.data.maxpaydate, "YYYY-MM-DD")
              .add(1, "days")
              .toDate()
          this.onloadLabourByDate(e.data.dc_docno, this.new_startday, e.data.dc_job_end_date);
          } else {
            this.onloadLabourByDate(e.data.dc_docno, e.data.dc_job_start_date, e.data.dc_job_end_date);
          }
          
        }

        if (e.wh == "expense") {
          this.dataFor = e.data;
          this.dataList.forEach((v, i) => {
            this.dataFor.forEach((v2, i2) => {
              let v_exp =
                $linq(this.expData)
                  .where(x => x.expens_code == v2.expens_code)
                  .firstOrDefault() || null;
              if (v_exp == null) {
                this.$set(v, v2.expens_code, 0);
                this.expData.push(v2);
              }
            });
          });
          this.expData = e.data;
        }
      },

      openprlist() {
        this.openprshow = true;
      },

      onExpense() {
        if (this.menuRight.isreadonly == 1) { return; }
        var old = this.expData;
        this.$refs.Ctexpenseother.onModalShow(old, "multi");
      },

      onLabour() {
        var type = 4
        this.$refs.Ctlabour.onModalShow(type);
      },

      onListPay(v) {
        this.$refs.Ctpaydetail.onModalShow(v.dc_docno);
      },

      //------------------------------ EDIT PAY LIST ----------------------------------------------------------
      onListPayEdit(item) {
        let routeData = this.$router.resolve({
          path: "/app/transaction/trn_labour_pay_ro_list",
          query: { dc_doc: item.dc_docno, docref: item.dc_docno_ref, startdate: item.dc_job_start_date, enddate: item.dc_job_end_date }
        });
        window.open(routeData.href, "_blank");
      },

    },

    beforeMount() {
      setTimeout(() => {
        if (xtools.isEmpty(this.$route.query.dc_docno)) {
          this.onLabour("Retrieve");
          this.$set(this, "loadingx", false);
        }
      }, 300);
    },

    mounted() {
      this.onHoliday();
      this.onLoadmainName();
      this.onloadLabourByDate(this.$route.query.dc_docno, this.$route.query.startdate, this.$route.query.enddate);

      $(document).ready(function () {
        document.title = 'Labour To Pay Share Service';
      });
      let ref = this;
      this.$nextTick(() => {

        $('#exporttoexcel').on('click', async () => {
          if (this.menuRight.issaveas == 1) { return; }
          // ref.checkExport = true;
          // var table = "payExportexcel"
          // var name = "xxx";
          // var uri = 'data:application/vnd.ms-excel;base64,'
          //   , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines /></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
          //   , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
          //   , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
          // if (!table.nodeType) table = document.getElementById(table)
          // var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML }
          // xtools.onSaveActionLogs(this.$route.meta.module, this.$route.meta.nameMenu + " [Pay To Excel]", this.dataH.dc_docno_ref);

          try {
          var table = "panel_export";
          if (!table.nodeType) table = document.getElementById(table);

          console.log(table.innerHTML);

          let f = {
            html: table.innerHTML,
          };
          let r = await xtools.postServerJson("api/file/HtmlToXls/", f);
          window.open(
            window.serverUrl + "api/file/download?download=true&id=" + r
          );
        } catch (ex) {
        } finally {
        }

        xtools.onSaveActionLogs(this.$route.meta.module, this.$route.meta.nameMenu + " [Pay To Excel]", this.dataH.dc_docno_ref);

        });
      })
    }
  };


  
</script>
<style scoped>
  .selected {
    color: red;
    background-color: #a7e6f4 !important;
  }

  .card .card-body {
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
  }

  .btn-group,
  .btn-group-vertical {
    position: relative;
    display: inline-flex;
    vertical-align: middle;
    width: 100%;
  }

  .zui-table {
    border-collapse: collapse;
    border-spacing: 0;
  }

    .zui-table thead th {
      text-align: center;
      /* background-color: #2f4050;
      border: 1px solid #5e81a1; */
      background-color: #eceff1;
      border: 1px solid #fff;
      color: #000;
      padding: 3px;
      height: 27px;
      border-radius: 2px;
      /* white-space: nowrap; */
      font-size: 0.7rem;
    }

    .zui-table tfoot th {
      text-align: center;
      background-color: #eceff1;
      border: 1px solid #fff;
      color: #000;
      padding: 0px;
      height: 25px;
      border-radius: 2px;
      white-space: nowrap;
    }

    .zui-table tbody td {
      cursor: pointer;
      border: solid 1px #f5f5f5;
      border-radius: 2px;
      color: #333;
      padding: 0px;
      height: 25px;
      font-size: 0.8rem;
    }

  .zui-wrapper {
    position: relative;
  }

  .zui-scroller {
    margin-left: 0px;
    overflow-x: scroll;
    overflow-y: visible;
    padding-bottom: 5px;
  }

  .zui-table .zui-sticky-col {
    border-right: solid 1px #ddefef;
    left: 0;
    top: auto;
    width: 0px;
    height: 25px;
  }

  .zui-table .widthClass {
    cursor: pointer;
  }

  .classdf {
    background-color: #fff !important;
    color: #000 !important;
    border: 1px solid #cfd8dc !important;
    text-align: center;
    font-weight: 700 !important;
  }

  .classActive {
    background-color: #90a4ae !important;
    color: #fff !important;
    border: 1px solid #cfd8dc !important;
    text-align: center;
    font-weight: 700 !important;
  }

  .classYRED {
    /* background-color: #aaa !important;; */
    color: #fff !important;
    border: 1px solid #cfd8dc !important;
    background-color: #b71c1c !important;
    text-align: center;
    font-weight: 700 !important;
  }

  .classYGREEN {
    /* background-color: #aaa !important;; */
    color: #fff !important;
    border: 1px solid #cfd8dc !important;
    background-color: #4caf50 !important;
    text-align: center;
    font-weight: 700 !important;
  }

  .classX {
    /* background-color: #aaa !important;; */
    color: #fff !important;
    border: 1px solid #cfd8dc !important;
    background-color: #b71c1c !important;
    text-align: center;
    font-weight: 700 !important;
  }

  .classH {
    /* background-color: #aaa !important;; */
    color: #fff !important;
    border: 1px solid #cfd8dc !important;
    background-color: #e65100 !important;
    text-align: center;
    font-weight: 700 !important;
  }

  .classholiday {
    background-color: #eceff1;
    color: #000;
  }

  .modal .modal-header,
  .modal .modal-body,
  .modal .modal-footer {
    padding: 1rem;
  }

  .controlbox .btn-xs,
  .btn-group-xs > .btn {
    padding: 0.25rem 0.75rem 0.25rem 0.75rem;
    font-size: 0.76rem;
    line-height: 1.3;
    width: 38px;
  }

  .controlbox .btn {
    border-radius: 0px;
    outline: initial !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    -webkit-box-shadow: initial !important;
    box-shadow: initial !important;
    font-size: 0.8rem;
    padding-left: 3px;
    padding-right: 3px;
    -webkit-transition: background-color box-shadow 0.1s linear;
    transition: background-color box-shadow 0.1s linear;
    height: 30px;
    border: 0px solid #fff;
  }

  ol,
  ul,
  dl {
    margin-top: 0;
    margin-bottom: 0rem;
  }

  .topClass {
    margin-top: 20px;
    padding: 5px;
  }

  .textClass {
    font-size: 14px;
  }

  .classHover:hover {
    background-color: #4caf50;
    color: #fff;
  }

  .classStatusActive {
    background-color: #4caf50 !important;
    color: #fff !important;
  }

  .page-item {
    padding-top: 0px !important;
    padding-right: 5px !important;
    padding-left: 5px !important;
    padding-bottom: 0px !important;
  }

  .classActiveX {
    background-color: #b71c1c !important;
    color: #fff !important;
    text-align: center;
  }

  .classActiveH {
    background-color: #e65100 !important;
    color: #fff !important;
    text-align: center;
  }

  .classActiveY {
    background-color: #f1c40f !important;
    color: #fff !important;
    text-align: center;
  }

  .classActivePay {
    background-color: #009688 !important;
    color: #fff !important;
    text-align: center;
  }

  .classActivePayD {
    background-color: #009688 !important;
    color: #fff !important;
    text-align: center;
    border: 1px solid #b2dfdb !important;
  }

  .classActivePaytrueD {
    background-color: #795548 !important;
    color: #fff !important;
    text-align: center;
    border: 1px solid #d7ccc8 !important;
  }

  .classActivePaytrue {
    background-color: #795548 !important;
    color: #fff !important;
    text-align: center;
  }

  .classCh {
    background-color: #ff6f00 !important;
    color: #fff !important;
    text-align: center;
  }

  .tableMain {
    color: #333;
    width: 640px;
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
  }

  .successfully {
    color: #2e7d32;
    font-weight: 700;
  }

  .inprogress {
    color: #c62828;
    font-weight: 700;
  }

  .disabled-menu {
    opacity: 0.65;
    cursor: not-allowed;
  }
</style>
